<template>
    <v-row no-gutters>
        <v-col cols="12">
            <!-- hierarchical navigation -->
            <!-- <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'user-dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-account-list' }">Accounts</router-link> &gt;
                    <router-link :to="{ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } }">{{ accountName }}</router-link> &gt;
                    <router-link :to="{ name: 'account-search-domain', params: { accountId: this.$route.params.accountId } }">Domains</router-link>
                </p>
                </v-col>
            </v-row> -->
            <v-row justify="center" class="py-5 px-10 mt-8">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                    <h1 class="text-h6 font-weight-light text-center">Is the domain already registered?</h1>
                <!-- <h1 class="text-h6 font-weight-light text-center">{{ accountName }}</h1> -->
                <!-- <p class="text-caption text-center">Add a domain</p> -->
                <!-- <p class="grey--text text--darken-2 mx-6 mt-6">Yes: skip to "manage a registered domain".</p>
                <p class="grey--text text--darken-2 mx-6">No: go to "register a new domain", then come back to this page to "manage a registered domain"</p> -->
                </v-col>
            </v-row>
            <v-row justify="center" class="py-5 px-10">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                    <!-- Add an existing domain (requires verification) -->
                    <v-card tile elevation="4" class="pa-0 mt-0">
                        <v-toolbar short flat color="white">
                            <v-toolbar-title :style="primaryTextStyle">
                                <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
                                <span class="ml-2">Yes</span>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <p>You will need to verify control of the domain before it is added to your account.</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="4" :style="primaryButtonStyle" :to="{ name: 'account-create-domain-verify', params: { accountId: this.$route.params.accountId }, query: { domain: this.$route.query.domain } }">
                                <span>Continue</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                    <!-- Register new domain -->
                    <v-card tile elevation="4" class="pa-0 mt-8 mb-6">
                        <v-toolbar short flat color="white">
                            <v-toolbar-title :style="primaryTextStyle">
                                <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
                                <span class="ml-2">No</span>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <p>Use a domain registrar to register a new domain, then return to this page.</p>
                        </v-card-text>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Where can I register a new domain?</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p class="text-caption">
                                        <font-awesome-icon :icon="['fas', 'info-circle']" class="blue--text"/>
                                        This information is provided for your convenience only. We do <em>NOT</em> make any endorsement about the reliability or customer experience for any of these registrars. Check ratings and reviews before selecting a registrar.</p>
                                    <!-- Here we should list the registrars for which we have some integration, for example direct links to their dns editing pages, etc. -->
                                    <p><TextLink href="https://godaddy.com" target="_blank">GoDaddy</TextLink></p>
                                    <!-- <p><TextLink href="https://www.namecheap.com" target="_blank">Namecheap</TextLink></p> -->
                                    <p><TextLink href="https://duckduckgo.com/?q=best+domain+registrars" target="_blank">Find more...</TextLink></p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isValidName, compact } from '@/sdk/input';
import TextLink from '@/components/TextLink.vue';

export default {
    components: {
        TextLink,
    },
    data: () => ({
        account: null,
        error: null,
        newDomainName: null,
        newDomainNameRules: [
            (v) => !!v || 'Display name is required',
            (v) => !v || isValidName(compact(v)) || 'Domain name is required',
        ],
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
        }),
        ...mapGetters({
            primaryColor: 'primaryColor',
            primaryButtonStyle: 'primaryButtonStyle',
            primaryTextStyle: 'primaryTextStyle',
        }),
        accountName() {
            return this.account?.name ?? 'Unknown';
        },
    },
    methods: {
        async loadAccount() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadAccount: true });
                const response = await this.$client.account(this.$route.params.accountId).self.get();
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.account = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadAccount: false });
            }
        },
        async create() {
            try {
                this.error = false;
                this.$store.commit('loading', { createDomain: true });
                console.log('createDomain');
                const request = {
                    // name: this.name,
                    name: this.newDomainName,
                    // agreeToTerms: this.isAgreeToTermsChecked,
                    // interactionId: this.interactionId, // will be present if domain arrives from an existing interaction, such as clicking on a specific link to get started and we can use this to redirect the domain to an appropriate location after domain is created
                };
                const response = await this.$client.account(this.$route.params.accountId).domain.create(request);
                console.log('createDomain response: %o', response);
                const { isCreated, error } = response;
                if (!isCreated && error) {
                    switch (error) {
                    case 'DOMAIN_VERIFICATION_REQUIRED':
                        this.$router.push({ name: 'account-verify-domain', params: { accountId: this.$route.params.accountId, domain: this.newDomainName } });
                        break;
                    case 'DOMAIN_ALREADY_CLAIMED':
                        this.$router.push({ name: 'account-dispute-domain', params: { accountId: this.$route.params.accountId, domain: this.newDomainName } });
                        break;
                    case 'UNKNOWN':
                    default:
                        this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to create domain', message: 'Unknown error' });
                        break;
                    }
                }
                if (isCreated) {
                    this.$router.push({ name: 'account-view-domain', params: { accountId: this.$route.params.accountId, domain: this.newDomainName } });
                }
            } catch (err) {
                console.error('failed to create domain', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { createDomain: false });
            }
        },
        cancel() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.loadAccount();
    },
};
</script>
